import MultiPackagePrintScaffold from '../../components/MultiPackagePrintScaffold/MultiPackagePrintScaffold';
import useMultiPackagePrintWorkflow, {
  type MultiPackageSharedSettings,
  type MultiPackageSourceIdentity,
} from '../../hooks/useMultiPackagePrintWorkflow';
import type { PrintPackageMode } from '../../types/multiPackagePrint';
import type { Product } from '../../wysiwyg/packageUtils';

export { buildMultiPackagePrintRequest } from '../../hooks/useMultiPackagePrintWorkflow';
export type { MultiPackageSharedSettings, MultiPackageSourceIdentity } from '../../hooks/useMultiPackagePrintWorkflow';

type Props = {
  enabled?: boolean;
  source: MultiPackageSourceIdentity | null;
  settings: MultiPackageSharedSettings | null;
  products?: Product[];
  mode: PrintPackageMode;
  onModeChange: (mode: PrintPackageMode) => void;
  onValidateSettings?: () => boolean;
};

export default function MultiPackagePrintFeature({ products = [], onModeChange, onValidateSettings, ...props }: Props) {
  const { active, ...workflow } = useMultiPackagePrintWorkflow(props);
  if (!active) return null;
  return <MultiPackagePrintScaffold
    {...workflow}
    onGenerate={() => {
      if (onValidateSettings?.() !== false) workflow.onGenerate();
    }}
    mode={props.mode}
    onModeChange={onModeChange}
    productOptions={products.map((product) => ({ id: product.id, name: product.name }))}
  />;
}
